import { EXIT_URL } from '../../utils/helpers/api.routes';
import {requests} from '../../utils/helpers/api.services';

export const ExitService = {
    putExit: () => requests.put(EXIT_URL),
}